/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useUpdateAnomalyThresholdMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";

export function useUpdateAnomalyThreshold() {
  const [updateAnomalyThreshold, { loading }] =
    useUpdateAnomalyThresholdMutation();

  async function update(newThreshold: number) {
    try {
      await updateAnomalyThreshold({
        variables: {
          input: {
            threshold: newThreshold,
          },
        },
      });
      showSuccess(
        `Threshold has been successfully changed. 
        Cost anomaly detection will be triggered now 
        when costs will diverge by ${newThreshold}%`,
        5000
      );
    } catch (error) {
      showError(`Threshold could not be changed. Please try again later.`, {
        autoClose: 5000,
      });
      throw error;
    }
  }

  return { update, loading };
}
